import NavigationTabs from './navigation-tabs';
export default NavigationTabs;
